import React, { useState } from 'react';
import { Button, Col, Container, Form, FormCheck, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {MdRemoveRedEye} from 'react-icons/md';
import {ImGoogle} from 'react-icons/im';
import {FaFacebookF} from 'react-icons/fa';
import {GoogleLogin} from 'react-google-login';


import './SignUp.css';

function SignUpPage() {

    const [clicked, setClicked]= useState(true);

    const [logData, setLogData]= useState({
        firstName:'',
        lastName:'',
        email:'',
        password1:'',
        password2:'',
        
    });
    // const pass1= logData.password1;
    // const pass2= logData.password2
 
     function handleShow(){
         setClicked(!clicked)
     }
     function handleChange(e){
         if (e.target.name === 'passwordun'){
             setLogData({...logData,password1:e.target.value})
         }else if(e.target.name === 'passworddeux'){
            setLogData({...logData,password2:e.target.value})
         }
     }
     function handleSubmit(){

     }

    return (
        // <div className='Background'>
        //     <div className='SignUp-Container'>
        //         <Row style={{width:'100%',margin:'auto'}}>
        //         <Col xl={8} lg={8} md={12} sm={12} xs={12} className='Col8-container' >
        //                 <h1 className='BigBox-header'>Your Profile</h1>
        //             <div className='BoxColBackground'>
        //                     <div className='Box1-header'>
        //                         <h2 className='Box1-title'>profile information</h2>
        //                     </div>
        //                 <div>
        //                     <Row>
        //                         <Col xl={6} lg={6} md={6} sm={12} xs={12}>
        //                             <FormGroup>
        //                                 <FormControl type='text' required placeholder='First Name *' className='formControlS' />
        //                             </FormGroup>
        //                         </Col>
        //                         <Col xl={6} lg={6} md={6} sm={12} xs={12}>
        //                             <FormGroup>
        //                                 <FormControl type='text' required placeholder='Last Name *' className='formControlS' />
        //                             </FormGroup>
        //                         </Col>
        //                     </Row>
        //                     <Row>
        //                         <Col xl={6} lg={6} md={6} sm={12} xs={12}>
        //                             <FormGroup>
        //                                 <FormControl type='text' required placeholder='Email Address *' className='formControlS' />
        //                             </FormGroup>
        //                         </Col>
        //                         <Col xl={6} lg={6} md={6} sm={12} xs={12}>
        //                             <FormGroup>
        //                                 <FormControl type='text' required placeholder='Confirm Email Address *' className='formControlS' />
        //                             </FormGroup>
        //                         </Col>
        //                     </Row>
        //                 </div>
        //                 </div>
        //                 <div className='BoxColBackground'>
        //                     <div className='Box1-header'>
        //                         <h2 className='Box1-title'>password</h2>
        //                     </div>
        //                 <div>
        //                     <Row>
        //                         <Col xl={6} lg={6} md={6} sm={12} xs={12}>
        //                             <FormGroup>
        //                                 <FormControl type='password' required placeholder='Create Password *' className='formControlS' />
        //                             </FormGroup>
        //                         </Col>
        //                         <Col xl={6} lg={6} md={6} sm={12} xs={12}>
        //                             <FormGroup>
        //                                 <FormControl type='password' required placeholder='Confirm Password *' className='formControlS' />
        //                             </FormGroup>
        //                         </Col>
        //                     </Row>
        //                     <Row>
        //                         <Col xl={6} lg={6} md={6} sm={12} xs={12}>
        //                             <div>
        //                                 <p className='formControlSp'>
        //                                     At least 8 characters long, case sensitive,can contain !$#%,
        //                                     no spaces, not the same as previous password or login
        //                                 </p>
        //                             </div>
        //                         </Col>
        //                         <Col xl={6} lg={6} md={6} sm={12} xs={12}>
        //                             {/* <FormGroup>
        //                                 <FormControl type='text' placeholder='Confirm Email Address' className='formControlS' />
        //                             </FormGroup> */}
        //                         </Col>
        //                     </Row>
        //                 </div>
        //                 </div>
        //                 <div className='acknowlegementBox'>
        //                     <h1 className='Box1-title'>Acknowlegment</h1>
        //                     <FormGroup>
        //                         <FormCheck  className='CheckBox' type='checkbox' label='* I agree with the privacy terms' />
        //                     </FormGroup>
        //                     <FormGroup>
        //                         <FormCheck className='CheckBox' type='checkbox' label='* I would like to create an account' />
        //                     </FormGroup>
        //                 </div>
        //                 <Row className='validationBox'>
        //                     <Button type='reset' className='cancel'>Cancel</Button>
        //                     <button  type='submit'  className='create'>Create</button>
        //                 </Row>
        //             </Col>
        //         </Row>
        //     </div>
        // </div>

        <div className='Background2'>
        <Form className='SignUp-Container2'>
            <h3 style={{textAlign:'center'}}>Sign-Up</h3>
            <FormGroup>
                <FormLabel>FirstName</FormLabel>
                <FormControl required type='text' value={logData.firstName} size='md' onChange={(e)=>setLogData({...logData,firstName:e.target.value})}  />
            </FormGroup>
            <FormGroup>
                <FormLabel>LastName</FormLabel>
                <FormControl required type='text' value={logData.lastName} size='md' onChange={(e)=>setLogData({...logData,lastName:e.target.value})}  />
            </FormGroup>
            <FormGroup>
                <FormLabel>Email</FormLabel>
                <FormControl required type='email' value={logData.email} size='md' onChange={(e)=>setLogData({...logData,email:e.target.value})} placeholder='eg: Vincentk@gmail.com' />
            </FormGroup>
            <FormGroup>
                <FormLabel>Password</FormLabel>
                <FormControl required name='passwordun' value={logData.password1} type={clicked?'password':'text'} size='md' onChange={
                                                                        // (e)=>setLogData({...logData,password1:e.target.value})
                                                                        handleChange
                                                                        }  />
                <MdRemoveRedEye className='eye' onClick={handleShow} />
            </FormGroup>
            <FormGroup>
                <FormLabel>Confirm Password</FormLabel>
                <FormControl required name='passworddeux' value={logData.password2} type='text' size='md' onChange={
                                                                        // (e)=>setLogData({...logData,password2:e.target.value})
                                                                        handleChange
                                                                        }  />
                {/* {
                    logData.password1 !== logData.password2 ? <span style={{color:'red'}}>Passwords don't match!</span>:null 
                
                } */}
                {
                        (() => {
                            if( logData.password2!=='')
                                if(logData.password1 !== logData.password2)
                                return <span style={{color:'red'}}>Passwords don't match!</span>
                                else
                                return null;
                            else
                            return null
                        })()
                }
            </FormGroup>
            <div className='sbtlogin'>
                <Button className='loginBtn' disabled={logData.password1 !== logData.password2 && logData.password2!=='' ?true:false}   type='submit' onSubmit={handleSubmit}>Register</Button>
            </div>
            
            <div className='social'>
                
                <Button className='GoogleBtn'><ImGoogle className='GoogleIcon' /> SignUp with Google</Button>
                <Button className='FacebookBtn'><FaFacebookF className='FacebookIcon' /> SignUp with Facebook</Button>
            </div>
            <hr/>
            <div>
                <span>Already a user?</span>
                <Link to='/signin' style={{color:'green',paddingLeft:'5px'}} >signin here</Link>
            </div>
        </Form>
    </div>
    )
}

export default SignUpPage
